import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Movie } from '../../types';
import { movieService } from '../../services/api';
import MovieCard from '../MovieCard';

const TrendingMovies: React.FC = () => {
  const [movies, setMovies] = useState<Movie[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMovies = async () => {
      try {
        const moviesData = await movieService.getMovies(1, { per_page: 50 });
        setMovies(moviesData.slice(0, 6));
      } catch (error) {
        console.error('Failed to load trending movies:', error);
      } finally {
        setLoading(false);
      }
    };

    loadMovies();
  }, []);

  return (
    <div className="relative px-4 lg:px-8 py-4 lg:py-8 scroll-reveal">
      <div className="container mx-auto relative z-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 lg:mb-6">
          <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold mb-2 sm:mb-0 pink-gradient-text">
            Trending Movies
          </h2>
          <Link 
            to="/movies" 
            className="text-netflix-light-gray hover:text-white flex items-center gap-2 text-sm sm:text-base"
            title="Browse all movies"
          >
            View All <i className="fas fa-angle-right"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 sm:gap-3 lg:gap-6">
          {loading ? (
            // Skeleton loaders
            Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-[2/3] bg-white/10 rounded-lg"></div>
                <div className="h-3 bg-white/10 rounded mt-2"></div>
                <div className="h-2 bg-white/10 rounded mt-1 w-3/4"></div>
              </div>
            ))
          ) : (
            movies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default TrendingMovies;
